import React from 'react'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as instructorActions from '../../_actions/roster.actions'
import _ from 'lodash'
import BigCalendar from 'react-big-calendar'
import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop'
// import 'react-big-calendar/lib/css/react-big-calendar.css'
// import 'react-big-calendar/lib/addons/dragAndDrop/styles.css'

import RosterPreview from '../etimeform/RosterPreview'
// react-bootstrap modal
// import Draggable from 'react-draggable'
// import Button from 'react-bootstrap/lib/Button';
// import Modal from 'react-bootstrap/Modal'
// import * as ModalDialog from 'react-bootstrap/ModalDialog'

import { Dialog } from 'primereact/dialog'
import { DndProvider } from 'react-dnd'
import TimeUtils from '../../utils/TimeUtils'

import ToolBar from './AbsenceToolbar'
import BrancheSelect from '../common/BrancheSelect'
import DepartmentSelect from '../common/DepartmentSelect'

import { toast } from 'react-toastify'

toast.configure()

const moment = require('moment')
const localizer = BigCalendar.momentLocalizer(moment)
const DragAndDropCalendar = withDragAndDrop(BigCalendar, DndProvider)

const WHOLE_DAY = 86400000
const NORMALWORKING_ACTION = 99

const ActionTypes = {
    NORMAL_WORKING: NORMALWORKING_ACTION,
    ANNUAL_LEAVE: 1,
    SICK_LEAVE: 2,
    ALTERNATIVE_LEAVE: 3,
    BEREAVEMENT_LEAVE: 4,
    LONGSERVICE_LEAVE: 5,
    SPECIAL_SERVICE_LEAVE: 6,
    DOMESTIC_LEAVE: 7,
    OTHER_PAID_LEAVE: 8,
    UNPAID_LEAVE: 9,
    OVERTIME_LIEU_LEAVE: 10,
    STUDY_LEAVE: 11,
    BIRTHDAY_LEAVE: 12,
    PARENTAL_LEAVE: 13,
}

// class DraggableModalDialog extends React.Component {
//     render() {
//         return (
//             <Draggable handle=".modal-title">
//                 <ModalDialog {...this.props} />
//             </Draggable>
//         )
//     }
// }

class AbsenceViewRoster extends React.PureComponent {
    state = {
        currentMonth: new Date(),
        selectedDate: new Date(),
        showModal: false,
        event: {},
        events: [],
        employees: [],
        displayEmployees: [],
        show: false,
        activeTab: '1',
        selectedBranch: {},
        selectedDepartment: {},
        mounted: false,
        modalActionType: '',
    }

    componentDidMount() {
        const { displayAbsenceEvents, branches, departments } = this.props
        if (_.isEmpty(displayAbsenceEvents)) {
            // this.props.actions.fetchUserETime()
        }

        if (branches.length === 0) {
            this.props.actions.fetchBranchList()
        }

        if (departments.length === 0) {
            this.props.actions.fetchDepartmentList()
        }

        this.setState({ mounted: true })
    }

    handleBranchChange = branch => {
        // const { selectedEmployee } = this.props;
        const { selectedDepartment } = this.state
        let filterCond = {}
        if (branch.value !== 'all') {
            filterCond.branch = branch.value
        }
        if (selectedDepartment.value && selectedDepartment.value !== 'all') {
            filterCond.department = selectedDepartment.value
        }
        filterCond.view = 'absence'
        this.props.actions.updateWorkAbsenceViewDisplayEvents(filterCond)
        this.setState({
            selectedBranch: branch,
        })

        // if current selected employee is not on the list, reset events to empty
        // this.resetEvents();
    }
    handleDepartmentChange = department => {
        const { selectedEmployee } = this.props
        const { selectedBranch } = this.state

        let filterCond = {}
        if (department.value !== 'all') {
            filterCond.department = department.value
        }
        if (selectedBranch.value && selectedBranch.value !== 'all') {
            filterCond.branch = selectedBranch.value
        }
        filterCond.view = 'absence'

        // const filteredEmployees = _.filter(employees, filterCond);
        this.props.actions.updateWorkAbsenceViewDisplayEvents(filterCond)
        this.setState({
            selectedDepartment: department,
        })
    }

    handleOpenModal = () => {
        this.setState({ showModal: true })
    }

    handleCloseModal = () => {
        this.setState({ showModal: false })
    }

    handleClose = () => {
        this.setState({ show: false })
    }

    handleShow = () => {
        this.setState({ show: true })
    }

    onFormHide = () => {
        this.setState({ modalActionType: '' })
    }

    moveEvent = ({ event, start, end, isAllDay: droppedOnAllDaySlot }) => {
        const { events, selectedEmployee } = this.props

        if (event.source === 'timesheet') {
            toast.warning('Read only event!', {
                position: 'top-center',
                // autoClose: 30000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            })
            return
        }

        let allDay = event.allDay

        if (!event.allDay && droppedOnAllDaySlot) {
            allDay = true
        } else if (event.allDay && !droppedOnAllDaySlot) {
            allDay = false
        }

        const updatedEvent = { ...event, start, end, allDay }

        this.props.actions.updateEvent(
            updatedEvent,
            this.props.selectedEmployee
        )
    }

    extendEvent = (event, start, end, sameStart, sameEnd) => {
        const newStartTime = TimeUtils.extractTime(event.start)
        const newEndTime = TimeUtils.extractTime(event.end)

        const minStart = moment.min([moment(start), moment(event.start)])
        const maxEnd = moment.max([moment(end), moment(event.end)])

        //
        const adjustedMaxEnd =
            sameStart || sameEnd ? maxEnd.subtract(1, 'days') : maxEnd

        const eventStart = moment(TimeUtils.extractDate(minStart))
        const eventEnd = moment(TimeUtils.extractDate(maxEnd))

        let day = eventStart
        const cloneEvent = _.clone(event)

        while (day <= adjustedMaxEnd) {
            cloneEvent.start = moment(
                TimeUtils.combineDateNTime(day.clone(), newStartTime)
            )
            cloneEvent.end = moment(
                TimeUtils.combineDateNTime(day.clone(), newEndTime)
            )

            day.add(1, 'days')

            // exclude same event
            if (
                cloneEvent.start.isSame(event.start) &&
                cloneEvent.end.isSame(event.end)
            ) {
                console.log('same event')
            } else {
                delete cloneEvent.id
                console.log(JSON.stringify(cloneEvent))
                this.props.actions.addEvent(
                    cloneEvent,
                    this.props.selectedEmployee
                )
            }
        }
    }

    resizeEvent = ({ event, start, end }) => {
        const { displayAbsenceEvents } = this.props

        const duration = moment(end).diff(start) == WHOLE_DAY // 24 hours
        const sameStart = moment(start).isSame(event.start)
        const sameEnd = moment(end).isSameOrAfter(event.end, 'day')
        const orgDuration = moment(event.end).diff(event.start) > WHOLE_DAY
        const sameDayEvent =
            moment(event.end).diff(event.start) < WHOLE_DAY &&
            moment(TimeUtils.extractDate(event.end)).isSame(
                TimeUtils.extractDate(event.start)
            )

        const nextEvents = _.find(displayAbsenceEvents, { id: event.id })

        // same day event
        if (sameDayEvent) {
            // repeatable event, expand to multiple days
            let period = 0
            if (sameStart) {
                period = moment(end).diff(event.start, 'days')
            } else if (sameEnd) {
                period = moment(event.end).diff(start, 'days')
            } else {
                period = moment(end).diff(start, 'days')
            }

            const multiple = period > 0

            if (multiple) {
                // repeat same event
                this.extendEvent(nextEvents, start, end, sameStart, sameEnd)
                console.log('')
            } else {
                // within same day
                const newStartDate = TimeUtils.extractDate(start)
                const newStartTime = TimeUtils.extractTime(start)
                const newStart = TimeUtils.combineDateNTime(
                    newStartDate,
                    newStartTime
                )

                const newEndDate = TimeUtils.extractDate(end)
                const newEndTime = TimeUtils.extractTime(end)
                const newEnd = TimeUtils.combineDateNTime(
                    newEndDate,
                    newEndTime
                )

                nextEvents.start = moment(newStart)
                nextEvents.end = moment(newEnd)
                nextEvents.allDay = false
                this.props.actions.updateEvent(
                    nextEvents,
                    this.props.selectedEmployee
                )
            }
        }

        // whole period event, not repeatable
        if (!sameDayEvent) {
            // resize to the one day
            if (duration && (sameStart || sameEnd) && orgDuration) {
                const newEvtDate = sameStart
                    ? TimeUtils.extractDate(start)
                    : TimeUtils.extractDate(end)

                const sTime = TimeUtils.extractTime(event.start)
                const newStartDate = TimeUtils.combineDateNTime(
                    newEvtDate,
                    sTime
                )

                const eTime = TimeUtils.extractTime(event.end)
                const newEndDate = TimeUtils.combineDateNTime(newEvtDate, eTime)

                nextEvents.start = moment(newStartDate)
                nextEvents.end = moment(newEndDate)
                nextEvents.allDay = false
            } else {
                // extend to multiple days
                const overOneDay = moment(end).diff(event.start) > WHOLE_DAY

                if (overOneDay) {
                    const newStartDate = TimeUtils.extractDate(start)
                    const newStartTime = TimeUtils.extractTime(event.start)
                    const newStart = TimeUtils.combineDateNTime(
                        newStartDate,
                        newStartTime
                    )

                    // expand over one day event, same start, then -1 day
                    const oneDay = moment.duration(1, 'd')
                    const newEndDate = sameStart
                        ? TimeUtils.extractDate(moment(end).subtract(oneDay))
                        : TimeUtils.extractDate(end)
                    const newEndTime = TimeUtils.extractTime(event.end)
                    const newEnd = TimeUtils.combineDateNTime(
                        newEndDate,
                        newEndTime
                    )

                    nextEvents.start = moment(newStart)
                    nextEvents.end = moment(newEnd)
                    nextEvents.allDay = false
                } else {
                    // within same day
                    const newStartDate = TimeUtils.extractDate(start)
                    const newStartTime = TimeUtils.extractTime(start)
                    const newStart = TimeUtils.combineDateNTime(
                        newStartDate,
                        newStartTime
                    )

                    const newEndDate = TimeUtils.extractDate(end)
                    const newEndTime = TimeUtils.extractTime(end)
                    const newEnd = TimeUtils.combineDateNTime(
                        newEndDate,
                        newEndTime
                    )

                    nextEvents.start = moment(newStart)
                    nextEvents.end = moment(newEnd)
                    nextEvents.allDay = false
                }
            }
            this.props.actions.updateEvent(
                nextEvents,
                this.props.selectedEmployee
            )
        }
    }

    disableSelect = e => {}
    newEvent = event => {
        let eTimeRequest = {
            id: '',
            EmployeeID: '',
            title: '',
            actionType: {
                label: 'Annual Leave',
                value: ActionTypes.ANNUAL_LEAVE,
            },
            allDay: event.slots.length == 1,
            dateFrom: event.start,
            dateTo: event.slots.length > 1 ? event.end : undefined,
            draggable: true,
            status: 'edit',
            startTime: TimeUtils.extractTime(event.start),
            endTime: TimeUtils.extractTime(event.end),
            duration: '',
            break: event.break || '0',
            hours: 1,
            note: '',
            existing: false,
        }

        this.setState({ event: eTimeRequest })
        this.setState({ modalActionType: 'create' })
    }

    customEventPropGetter = event => {
        const eventType = event.ActionType
        if (eventType) {
            switch (eventType) {
                case ActionTypes.NORMAL_WORKING:
                    return {
                        className: 'boxGreen',
                    }
                case ActionTypes.ANNUAL_LEAVE:
                    return {
                        className: 'boxTomato',
                    }
                case ActionTypes.SICK_LEAVE:
                    return {
                        className: 'boxOrange',
                    }
                case ActionTypes.ALTERNATIVE_LEAVE:
                    return {
                        className: 'boxDodgerBlue',
                    }
                case ActionTypes.BEREAVEMENT_LEAVE:
                    return {
                        className: 'boxMediumSeaGreen',
                    }
                case ActionTypes.OVERTIME_LIEU_LEAVE:
                    return {
                        className: 'boxGray',
                    }
                case ActionTypes.OTHER_PAID_LEAVE:
                    return {
                        className: 'boxViolet',
                    }
                case ActionTypes.PARENTAL_LEAVE:
                    return {
                        className: 'boxSlateBlue',
                    }
                case ActionTypes.UNPAID_LEAVE:
                    return {
                        className: 'boxLightGray',
                    }
                case ActionTypes.LONGSERVICE_LEAVE:
                    return {
                        className: 'boxLight-1',
                    }
                case ActionTypes.SPECIAL_SERVICE_LEAVE:
                    return {
                        className: 'boxLight-2',
                    }
                case ActionTypes.DOMESTIC_LEAVE:
                    return {
                        className: 'boxLight-3',
                    }
                case ActionTypes.STUDY_LEAVE:
                    return {
                        className: 'boxLight-4',
                    }
                case ActionTypes.BIRTHDAY_LEAVE:
                    return {
                        className: 'boxLight-5',
                    }
                default:
                    return {
                        className: 'boxDodgerBlue',
                    }
            }
        } else return {}
    }

    customColorEventPropGetter = event => {
        const eventType = event.ActionType

        let companyId = null
        let branch = null
        let department = null
        if (event.Employee) {
            companyId = event.Employee.EmployeeCompanyID
            branch = event.Employee.EmployeeBranch
            department = event.Employee.EmployeeDepartment
        } else {
            const employeeId = event.EmployeeID

            const employee = _.find(
                this.props.displayEmployees,
                emp => emp.EmployeeAutoID == employeeId
            )
            companyId = employee.EmployeeCompanyID
            branch = employee.EmployeeBranch
            department = employee.EmployeeDepartment
        }

        const { colors } = this.props
        const customColor = _.find(
            colors || [],
            color =>
                color['PayrollCompanyID'] == companyId &&
                color['PayrollBranch'] == branch &&
                color['PayrollDepartment'] == department
        )

        if (eventType) {
            switch (eventType) {
                case ActionTypes.NORMAL_WORKING:
                    return {
                        style: {
                            backgroundColor: customColor
                                ? customColor.PayrollColorNormalCode
                                : '',
                        },
                        // className: 'boxGreen',
                    }
                default:
                    return {
                        style: {
                            backgroundColor: customColor
                                ? customColor.PayrollColorLeaveCode
                                : '',
                        },
                    }
            }
        } else return {}
    }

    renderEvetDetail = event => {
        let eTimeRequest = {
            id: event.id,
            employeeID: event.EmployeeID,
            title: event.Title || event.title,
            actionType: _.find(this.props.actionTypes, {
                value: event.ActionType,
            }),
            allDay: event.allDay,
            dateFrom: event.start,
            dateTo: event.end,
            startTime: TimeUtils.extractTime(event.start),
            endTime: TimeUtils.extractTime(event.end),
            duration: event.ActionHours || '',
            break: event.Break || 0,
            Note: event.Note || '',
            existing: true,
            hours: event.hours || 0,
            source: event.source,
            EmployeeName: event.EmployeeName,
        }

        this.setState({ event: eTimeRequest })
        this.setState({ modalActionType: 'update' })
    }

    removeEvent = event => {
        this.props.actions
            .removeEventById(this.state.event.id)
            .then(res =>
                _.head(document.getElementsByClassName('close')).click()
            )
            .catch(error => {
                console.log(`error=${error}`)
            })
    }

    // handleSelect = employeeId => {
    //   this.setState({ currentEmployee: employeeId });
    //   this.filterEvents(employeeId);
    // };

    filterWorkAbsenceEvents = (events, viewType) => {
        if (viewType === 'work') {
            const filteredEvents = _.filter(events, function(evt) {
                return evt.ActionType === NORMALWORKING_ACTION
            })

            _.sortBy(filteredEvents, ['start'])
            return filteredEvents
        } else {
            const filteredEvents = _.filter(events, function(evt) {
                return evt.ActionType !== NORMALWORKING_ACTION
            })
            _.sortBy(filteredEvents, ['start'])
            return filteredEvents
        }
    }

    render() {
        let allViews = Object.keys(BigCalendar.Views).map(
            k => BigCalendar.Views[k]
        )
        const { selectedEmployee } = this.props

        let components = {
            toolbar: ToolBar,
        }

        return (
            <div className="">
                <div className="row">
                    <div className="panel">
                        <div className="panel-heading">
                            <h3 className="panel-title">
                                Employee Absence View
                            </h3>
                        </div>
                        <div className="panel-body">
                            <div className="container">
                                <div className="row">
                                    <div className="col-sm-3">
                                        <div className="rosterToolBar">
                                            <BrancheSelect
                                                handleChange={this.handleBranchChange.bind(
                                                    this
                                                )}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm-3">
                                        <div className="rosterToolBar">
                                            <DepartmentSelect
                                                handleChange={this.handleDepartmentChange.bind(
                                                    this
                                                )}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="panel">
                                            <div className="panel-body">
                                                <div className="calendar">
                                                    <div className="example">
                                                        <DragAndDropCalendar
                                                            popup
                                                            selectable
                                                            localizer={
                                                                localizer
                                                            }
                                                            // events={this.props.displayAbsenceEvents}
                                                            events={_.map(
                                                                this.props
                                                                    .displayAbsenceEvents,
                                                                (obj, key) => {
                                                                    return obj
                                                                }
                                                            )}
                                                            onEventDrop={
                                                                this.moveEvent
                                                            }
                                                            resizable
                                                            onEventResize={
                                                                this.resizeEvent
                                                            }
                                                            onSelectEvent={
                                                                this
                                                                    .renderEvetDetail
                                                            }
                                                            onSelectSlot={
                                                                this.newEvent
                                                            }
                                                            views={['roster']}
                                                            defaultView={
                                                                BigCalendar
                                                                    .Views
                                                                    .ROSTER
                                                            }
                                                            defaultDate={
                                                                new Date()
                                                            }
                                                            eventPropGetter={
                                                                this
                                                                    .customColorEventPropGetter
                                                            }
                                                            titleAccessor="Title"
                                                            startAccessor="start"
                                                            endAccessor="end"
                                                            showMultiDayTimes={
                                                                true
                                                            }
                                                            draggableAccessor="draggable"
                                                            culture="en-NZ"
                                                            tooltipAccessor="Title"
                                                            step={1440}
                                                            timeslots={1}
                                                            classNameCustom="rbc-roster"
                                                            components={
                                                                components
                                                            }
                                                            employees={
                                                                this.props
                                                                    .employees
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                                {/* <div className="col-md-12">
                                                <ul className="list-inline flex-item-box flex-container wrap">
                                                    <li className="list-inline-item flex-item">
                                                        <div className="boxTomato">
                                                            <span>
                                                                Annual Leave
                                                            </span>
                                                        </div>
                                                    </li>
                                                    <li className="list-inline-item flex-item">
                                                        <div className="boxOrange">
                                                            <span>
                                                                Sick Leave
                                                            </span>
                                                        </div>
                                                    </li>
                                                    <li className="list-inline-item flex-item">
                                                        <div className="boxDodgerBlue">
                                                            <span>
                                                                Alternative
                                                                Leave
                                                            </span>
                                                        </div>
                                                    </li>
                                                    <li className="list-inline-item flex-item">
                                                        <div className="boxMediumSeaGreen">
                                                            <span>
                                                                Bereavement
                                                                Leave
                                                            </span>
                                                        </div>
                                                    </li>
                                                    <li className="list-inline-item flex-item">
                                                        <div className="boxGray">
                                                            <span>
                                                                Overtime in Lieu
                                                                Leave
                                                            </span>
                                                        </div>
                                                    </li>
                                                    <li className="list-inline-item flex-item">
                                                        <div className="boxViolet">
                                                            <span>
                                                                Other Paid Leave
                                                            </span>
                                                        </div>
                                                    </li>
                                                    <li className="list-inline-item flex-item">
                                                        <div className="boxSlateBlue">
                                                            <span>
                                                                Parental Leave
                                                            </span>
                                                        </div>
                                                    </li>
                                                    <li className="list-inline-item flex-item">
                                                        <div className="boxLightGray">
                                                            <span>
                                                                Unpaid Leave
                                                            </span>
                                                        </div>
                                                    </li>
                                                    <li className="list-inline-item flex-item">
                                                        <div className="boxLight-1">
                                                            <span>
                                                                Long Service
                                                                Leave
                                                            </span>
                                                        </div>
                                                    </li>
                                                    <li className="list-inline-item flex-item">
                                                        <div className="boxLight-2">
                                                            <span>
                                                                Special Service
                                                                Leave
                                                            </span>
                                                        </div>
                                                    </li>
                                                    <li className="list-inline-item flex-item">
                                                        <div className="boxLight-4">
                                                            <span>
                                                                Study Leave
                                                            </span>
                                                        </div>
                                                    </li>
                                                    <li className="list-inline-item flex-item">
                                                        <div className="boxLight-5">
                                                            <span>
                                                                Birthday Leave
                                                            </span>
                                                        </div>
                                                    </li>
                                                    <li className="list-inline-item flex-item">
                                                        <div className="boxLight-3">
                                                            <span>
                                                                Domestic Leave
                                                            </span>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div> */}
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        {/* Roster Preview Modal - Read-only */}
                                        {this.state.modalActionType === 'update' && this.state.event && this.state.event.id && (
                                            <RosterPreview
                                                event={this.state.event}
                                                onClose={this.onFormHide}
                                                employees={this.props.displayEmployees}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        events: state.roster.events,
        displayAbsenceEvents: state.roster.displayAbsenceEvents,
        displayEmployees: state.roster.displayEmployees,
        selectedEmployee: state.roster.selectedEmployee,
        branches: state.BranchReducer.branchList,
        departments: state.DepartmentReducer.departmentList,
        actionTypes: state.ActionTypesReducer.actionTypes,
        colors: state.colors.colors,
    }
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(instructorActions, dispatch) }
}

export default connect(mapStateToProps, mapDispatchToProps)(AbsenceViewRoster)
